import { render, staticRenderFns } from "./PagesBar.vue?vue&type=template&id=24c8e5f2&"
import script from "./PagesBar.vue?vue&type=script&lang=js&"
export * from "./PagesBar.vue?vue&type=script&lang=js&"
import style0 from "./PagesBar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports